import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { NotFound } from "@app/shared/ErrorPages";
import { JSX } from "react";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";
import { MaintenanceAdmin } from "@app/maintenance/MaintenanceAdmin";

/** Renders the routing components for the projects sub-section of the app. */
export default function MaintenanceRouter(props: RouteComponentProps): JSX.Element {
  return (
    <RoleRestricted allowedRoles={[Roles.MAINTENANCE_ADMIN]}>
      <Switch>
        <Route path={`${props.match.path}`} component={MaintenanceAdmin} />
        <Route component={NotFound} />
      </Switch>
    </RoleRestricted>
  );
}
